import { render, staticRenderFns } from "./info-pdf-viewer.vue?vue&type=template&id=3ed387aa&scoped=true"
import script from "./info-pdf-viewer.vue?vue&type=script&lang=js"
export * from "./info-pdf-viewer.vue?vue&type=script&lang=js"
import style0 from "./info-pdf-viewer.vue?vue&type=style&index=0&id=3ed387aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed387aa",
  null
  
)

export default component.exports